import { BaseController } from 'controllers/BaseController'
import { AggregateEventLevel } from 'model/ProjectEventLevel'
import {
  NotificationType,
  RememberBomItemAsPurchasingPartArgs,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { InternalAPI } from 'services/APIs/InternalAPI/InternalAPI'
import { store } from 'store/configureStore'
import { NotificationActions } from 'store/Notifications/NotificationActions'
import { GetPartyId } from 'store/storeUtils'

type IGeometryAPI = {
  RememberOrForgetGeometryAsPurchasingItem: (
    args: RememberBomItemAsPurchasingPartArgs
  ) => Promise<void>
}

class GeometryAPI extends InternalAPI implements IGeometryAPI {
  constructor(partyId: string, private onRequestChanged) {
    super(`/api/parties/${partyId}/geometries`)
  }

  public async RememberOrForgetGeometryAsPurchasingItem(
    args: RememberBomItemAsPurchasingPartArgs
  ) {
    return await this.PostAsync<void>({
      relativePath: '/setAsPurchasingPart',
      data: args,
      id: 'remember-geometry-as-purchasing-item',
      onRequestChange: this.onRequestChanged,
    })
  }
}

export class GeometryController extends BaseController<IGeometryAPI> {
  constructor() {
    super((onRequestChange) => new GeometryAPI(GetPartyId(), onRequestChange))
  }

  public async RememberOrForgetGeometryAsPurchasingItem(
    projectId: string,
    itemId: string,
    shallRemember: boolean,
    articleId?: string
  ) {
    try {
      store.dispatch(
        NotificationActions.AddNotification(projectId, {
          aggregateId: projectId,
          description: 'starting',
          aggregateLevel: AggregateEventLevel.Project,
          notificationType: NotificationType.Info,
          progress: -1,
        })
      )

      await this.api.RememberOrForgetGeometryAsPurchasingItem({
        projectId,
        itemId,
        shallRemember,
        articleId,
      })

      store.dispatch(
        NotificationActions.AddNotification(projectId, {
          aggregateId: projectId,
          description: 'done',
          aggregateLevel: AggregateEventLevel.Project,
          notificationType: NotificationType.Info,
          progress: 100,
        })
      )
    } catch (ex) {
      throw this.HandleError(ex)
    }
  }
}
